import React from 'react';
import LCSubPageLayout from './LCSubPageLayout';
import LCSocial from './LCSocial';

const LCSocialPage: React.FC = () => (
  <LCSubPageLayout title="Social">
    {(detail) => (
      <LCSocial
        id={detail.id}
        lcAccess={detail.local_chapter_access}
        lcAction={detail.local_chapter_action}
      />
    )}
  </LCSubPageLayout>
);

export default LCSocialPage;
